var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-bar',[_vm._t("default"),_c('go-back-btn')],2)}
var staticRenderFns = []

export { render, staticRenderFns }